import type { CopyShape } from "@tami/core/intl";

import type { CALENDAR_SCRIPT_COPY_PT_BR } from "../calendar-script.copy";

export const CALENDAR_SCRIPT_COPY_ES_ES: CopyShape<typeof CALENDAR_SCRIPT_COPY_PT_BR> = {
  calIntro: {
    narrative: "Planifica el mes entero en un calendario que se arrastra — publicaciones, entregas y citas en la misma vista.",
  },
  calGrid: {
    narrative: "Organiza el contenido por mes o semana, con la fecha, la hora y el formato de cada publicación.",
    callout: "Calendario que se arrastra: publis y orgánico en colores distintos para no confundirlos.",
  },
  calEventDetail: {
    narrative: "Al hacer clic en una cita ves lo que importa: cuándo, con quién y qué se acordó.",
    callout: "Reunión, grabación, llamada con la marca — la cita vive en el mismo sitio que el contenido.",
  },
  calPostDetail: {
    narrative:
      "Y al hacer clic en una publicación ves su detalle: en qué fase está, cuándo sale, cuánto vale, guion, notas y adjuntos.",
    callout: "Fase, plazo, importe y guion en una sola pantalla — sin abrir otra para enterarte.",
  },
  calCreate: {
    narrative: "El botón de añadir pregunta primero qué es: una cita o una publicación.",
    callout: "Dos cosas distintas, dos caminos — el color de la casilla ya es el que tendrá el elemento.",
  },
  calEventForm: {
    narrative: "En la cita marcas el día, la hora y quién participa — y entra en el calendario al momento.",
    callout: "Hora de inicio y fin, participantes y dónde es: lo justo, sin formularios eternos.",
  },
  calPostForm: {
    narrative: "Y la publicación abre la misma planificación del Centro de contenido, ya en la fecha elegida.",
    callout: "El mismo formulario del Centro de contenido — el calendario no se inventa otra forma de hacerlo.",
  },
  calOverview: {
    narrative: "Marca el contenido como publicado y sigue tu progreso a lo largo del mes.",
  },
  calSidebar: {
    narrative: "Las ideas y pendientes sin fecha van aparte — para que ninguna tarea se pierda con las prisas.",
    callout: "Lista 'para no olvidar': ideas y pendientes que todavía no tienen fecha.",
  },
  calOutro: {
    narrative: "Escribe guiones, añade enlaces y exporta — todo sin salir del calendario.",
  },
};
